// ─── Dashboard Slice ─────────────────────────────────────────────────────────
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import dashboardService from '../../services/dashboardService';

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchStats',
  async (_, { getState }) => {
    const { token } = getState().auth;
    return await dashboardService.getStats(token);
  }
);

export const fetchRecentActivities = createAsyncThunk(
  'dashboard/fetchActivities',
  async (_, { getState }) => {
    const { token } = getState().auth;
    return await dashboardService.getActivities(token);
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    stats: {
      totalEmployees: 0,
      activeProjects: 0,
      pendingInvoices: 0,
      monthlyRevenue: 0,
    },
    recentActivities: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => { state.loading = false; state.stats = action.payload; })
      .addCase(fetchDashboardStats.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchRecentActivities.fulfilled, (state, action) => { state.recentActivities = action.payload; });
  },
});

export default dashboardSlice.reducer;
